import Header from "@/components/Header";
import Hero from "@/components/Hero";
import ReviewsSection from "@/components/ReviewsSection";
import Footer from "@/components/Footer";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <Hero />
      <ReviewsSection />
      <Footer />
    </div>
  );
};

export default Index;
